/**
 *
 */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, NgZone, OnInit, Output } from '@angular/core';

/**
 *
 */
@Component({
  selector: 'app-ranking',
  templateUrl: './ranking.component.html',
  styleUrls: ['./ranking.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush

})
export class RankingComponent implements OnInit {

  /**
   * List of options.
   */
  @Input() options: string[] = [];
  @Input() isViewMode: boolean;

  /**
   * List to store ranks.
   */
  public ranks: { id: (number | null), value: string }[] = [];

  /**
   *
   */
  @Input() selectedDropdownCode: { [code: string]: any } = [];

  /**
   * Send selected rating outside.
   */
  @Output() emitSelected: EventEmitter<{ optionCode: string; selected: any }> = new EventEmitter();

  constructor(private cdRef: ChangeDetectorRef, private ngZone: NgZone) { }

  /**
   * Get the ranks according to the length of the options.
   */
  ngOnInit(): void {
    this.ranks = Array.from({ length: this.options.length }, (_, index) => ({ id: index + 1, value: (index + 1).toString() }));
    // this.selectedDropdownCode = JSON.parse(JSON.stringify(this.selectedDropdownCode));
    // this.cdRef.detectChanges();
  }

  /**
   * Track the indexed stream.
   */
  trackByCode(index, ques): void {
    return ques ? ques.code : undefined;
  }

  /**
   * Track the indexed stream.
   */
  trackByIndex(index, ques): void {
    return index ? index : undefined;
  }

  /**
   * Get the Selected ranking.
   */
  setDropDownOption(optionCode: string, selected: any): void {
    console.log('setDropDownOption', optionCode, selected, this.selectedDropdownCode);
    this.emitSelected.emit({ optionCode, selected });
  }

  updateSelectedValues(newValues: any): any {
    this.ngZone.runOutsideAngular(() => {
      return this.selectedDropdownCode[newValues];
    });
    return this.selectedDropdownCode[newValues];
  }
}
